import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class ToolsService {
    public media: any = false;
    private menuCollapse: boolean = true;
    public innerWidth: any;
    private collapseStatus = new BehaviorSubject({});
    public $collapseStatus = this.collapseStatus.asObservable();

    private mediaQuery920 = new BehaviorSubject({});
    public $mediaQuery920 = this.mediaQuery920.asObservable();

    private menu = new BehaviorSubject({});
    public $menu = this.menu.asObservable();

    private contentModal = new BehaviorSubject({});
    public $contentModal = this.contentModal.asObservable();

    constructor(private httpClient: HttpClient){
    }

    getFile(url): Observable<Blob>{
        return this.httpClient.request('GET' ,url , {responseType:'blob'});
    }
    updateModalContent (newContent: any) {
      this.contentModal.next(newContent);
    }

    searchInArray(array: string[], type: string) {
        let carsFilter = [];
        carsFilter.push(
            array.filter((car: any) => car.toLowerCase().indexOf((type.trim()).toLowerCase()) !== -1)
        );
        return carsFilter;
    }

    search(menu, query, recurso) {
        let treeFilter = this.findInto(menu, query, recurso);
        treeFilter[0] = treeFilter[0].filter((option: any) => {
          let resultado = false;
          resultado = ((option.categoria.toLowerCase()).indexOf(query.toLowerCase()) !== -1 || option[recurso].length > 0 )
          return resultado;
        });
        return treeFilter
      }

    findInto(tree: any, term: string, childrenName: string) {
        let treeFilter = []
        tree.forEach((n: any) => {
          const nClone = { ...n }
          let exist = false;
          if (nClone.hasOwnProperty('url') && nClone.hasOwnProperty('nombreRecurso')) {
            exist = (nClone.url.indexOf(term.toLowerCase()) !== -1 || (nClone.nombreRecurso.toLowerCase()).indexOf(term.toLowerCase()) !== -1);
          }
          if (nClone.hasOwnProperty(childrenName)) {
            if (nClone[childrenName] !== null) {
              const children = this.findInto(nClone[childrenName], term, childrenName);
              if (children.length > 0) {
                nClone[childrenName] = children[0];
                exist = true
              } else {
                exist = false
              }
            }
          }
          if (exist) {
            treeFilter = [...treeFilter, ...[nClone]];
          } else {
            treeFilter = [...treeFilter];
          }
        });
        return [treeFilter];
      }

    expand() {
        this.menuCollapse = true;
        this.collapseStatus.next(this.menuCollapse);
    }

    collapse() {
        this.menuCollapse = false;
        this.collapseStatus.next(this.menuCollapse);
    }

    updateMenu(menu: any){
        this.menu.next(menu);
    }

}